import { render, staticRenderFns } from "./ModelParams.vue?vue&type=template&id=7a584bba&scoped=true"
import script from "./ModelParams.vue?vue&type=script&lang=js"
export * from "./ModelParams.vue?vue&type=script&lang=js"
import style0 from "./ModelParams.vue?vue&type=style&index=0&id=7a584bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a584bba",
  null
  
)

export default component.exports